import { MOBILE_HEADER_OFFSET } from '@shared/config/header'

export const scrollToFirstErrorField = (errorFieldNames: string[], isMobile: boolean) => {
  const visibleElements = errorFieldNames
    .flatMap((name) => Array.from(document.querySelectorAll<HTMLElement>(`[name="${name}"]`)))
    .filter((el) => {
      const { width, height } = el.getBoundingClientRect()

      return width > 0 && height > 0
    })
    .sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top)

  const errorElement = visibleElements[0]

  if (!errorElement) return

  if (isMobile) {
    window.scrollBy({
      top: errorElement.getBoundingClientRect().top - MOBILE_HEADER_OFFSET,
      behavior: 'smooth',
    })
  } else {
    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  errorElement.focus({ preventScroll: true })
}
